import React, { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import {
  List,
  ListItemText,
  Box,
  ListItemIcon,
  ListItemButton,
  AppBar,
  IconButton,
  Divider,
} from '@mui/material'

import SUPLogo from '../assets/SUP-logo.jpg'
import { blue } from '@mui/material/colors'
import useIsAdmin from '../hooks/useIsAdmin'
import MiniDrawer from '../common/MiniDrawer'

import useIsMobile, { useScreenSize } from '../hooks/useIsMobile'
import { ChevronLeft, ChevronRight } from '@mui/icons-material'
import iconPageMap from './iconPageMap'

const emphasizedPaths = ['/customers', '/cardwall', '/lists']

const getColors = (path, pathname) => {
  const isEmphasized = emphasizedPaths.includes(path)

  const isActive = pathname.includes(path.split('/')[1])
  return {
    '&:hover': {
      background: `linear-gradient(180deg, ${blue[300]} 0%, ${blue[600]} 100%)`,
      borderColor: blue[900],
    },
    ...(isEmphasized
      ? {
          border: `1px solid ${blue[500]}`,
          background: `linear-gradient(180deg, ${blue[100]} 0%, ${blue[300]} 100%)`,
          borderColor: blue[700],
        }
      : {}),
    ...(isActive
      ? {
          border: `2px solid ${blue[900]}`,
          borderColor: blue[900],

          color: 'white',
          background: `linear-gradient(180deg, ${blue[300]} 0%, ${blue[700]} 100%)`,

          '&:hover': {
            background: `linear-gradient(180deg, ${blue[400]} 0%, ${blue[600]} 100%)`,
          },
        }
      : {}),
  }
}

const Nav = ({ open, setOpen }) => {
  const close = (event) => {
    // setOpen(false)
  }

  const { isAdmin } = useIsAdmin()

  const navigate = useNavigate()

  const getButtons = () => {
    const buttons = [
      iconPageMap['/dashboard'],
      iconPageMap['/customers'],
      iconPageMap['/cardwall'],
      iconPageMap['/lists'],
      iconPageMap['/support'],
    ]

    if (isAdmin) {
      buttons.push(iconPageMap['/settings'])
    }

    return buttons
  }

  const buttons = getButtons()

  const { pathname, search } = useLocation()

  const isMobile = useIsMobile()
  const { windowWidth } = useScreenSize()

  useEffect(() => {
    if (windowWidth < 1000 && open) {
      setOpen(false)
    }
  }, [windowWidth, open])

  if (pathname.includes('setup')) return null
  if (pathname.includes('/billing') && search.includes('unpaid=true'))
    return null

  if (isMobile)
    return (
      <MobileNav navigate={navigate} buttons={buttons} pathname={pathname} />
    )

  return (
    <MiniDrawer open={open} handleDrawerClose={close} setOpen={setOpen}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          mt: 3,
          mb: 6,
          height: '54px',
        }}
      >
        <img
          style={{
            width: open ? '150px' : '64px',
            transition: 'all 0.225s',
            objectFit: 'contain',
          }}
          src={SUPLogo}
        />
      </Box>

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          flexGrow: 1,
        }}
      >
        <List sx={{ pt: 0 }}>
          {buttons.map((b, i) => {
            return (
              <ListItemButton
                onClick={() => {
                  close()
                  navigate(b.navPath)
                }}
                key={i}
                sx={{
                  minHeight: 48,
                  justifyContent: open ? 'initial' : 'center',
                  // borderTop: i !== 0 ? 'none' : '1px solid #277EC5',
                  // borderRight: '1px solid #277EC5',
                  // borderLeft: '1px solid #277EC5',
                  // border: `1px solid ${blue[600]}`,
                  borderRadius: '3px',
                  my: '4px',
                  mx: '8px',

                  px: 4.5,
                  ...getColors(b.navPath, pathname),
                }}
              >
                <ListItemIcon
                  color='primary'
                  sx={{
                    color: blue[700],
                    minWidth: 0,
                    mr: open ? 3 : 'auto',
                    justifyContent: 'center',
                  }}
                >
                  {b.icon}
                </ListItemIcon>
                <ListItemText
                  primary={b.label}
                  sx={{
                    opacity: open ? 1 : 0,
                  }}
                />
              </ListItemButton>
            )
          })}
        </List>
        <Box>
          <Divider />
          <Box
            sx={{
              display: 'flex',
              justifyContent: open ? 'flex-end' : 'center',
              my: 2,
              px: 2,
            }}
          >
            <IconButton onClick={() => setOpen(!open)}>
              {open ? <ChevronLeft /> : <ChevronRight />}
            </IconButton>
          </Box>
        </Box>
      </Box>
    </MiniDrawer>
  )
}

const MobileNav = ({ navigate, buttons, pathname }) => {
  return (
    <AppBar
      position='fixed'
      color='transparent'
      sx={{ top: 'auto', bottom: 0 }}
    >
      <List
        sx={{
          flexDirection: 'row',
          display: 'flex',
          backgroundColor: 'white',
          p: 0,
        }}
      >
        {buttons.map((b, i) => (
          <ListItemButton
            key={i}
            onClick={() => {
              navigate(b.navPath)
            }}
            sx={{
              ...getColors(b.navPath, pathname),
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              py: 2,
              borderLeft: i === 0 ? null : `2px solid ${blue[600]}`,
              borderTop: `2px solid ${blue[600]}`,
            }}
          >
            <ListItemIcon
              color='primary'
              sx={{
                color: blue[700],
                minWidth: 0,

                justifyContent: 'center',
              }}
            >
              {b.icon}
            </ListItemIcon>
          </ListItemButton>
        ))}
      </List>
    </AppBar>
  )
}

export default Nav
